import type { Theme } from '@mui/material';

export const styles = {
  tabs: (theme: Theme) => ({
    position: 'relative',

    '.MuiTabs-indicator': {
      backgroundColor: theme.colors.error[600],
      height: '3px',
    },
  }),

  scrollButton: (theme: Theme) => ({
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    backgroundColor: theme.colors.white,
    opacity: 0.9,
    transition: 'opacity 0.2s ease-in-out',

    // Scroll to left button
    '&:first-of-type': {
      left: 0,
      borderTopRightRadius: '0.5rem',
      borderBottomRightRadius: '0.5rem',
    },

    // Scroll to right button
    '&:last-of-type': {
      right: 0,
      borderTopLeftRadius: '0.5rem',
      borderBottomLeftRadius: '0.5rem',
    },
  }),

  tab: (theme: Theme) => ({
    backgroundColor: theme.colors.secondary[50],
    color: theme.colors.secondary[800],
    fontWeight: theme.typography.fontWeightSemiBold,
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    marginRight: 1,
    transition: theme.transitions.create('background-color'),

    '&:hover': {
      backgroundColor: theme.palette.background.default,
    },

    '&.Mui-selected': {
      backgroundColor: theme.palette.background.default,
      color: theme.colors.error[600],
    },
  }),
};
